import React from 'react';
import { Edit2, Trash2, Power } from 'lucide-react';

const ProductGrid = ({
  products,
  selectedProduct,
  onSelectProduct,
  onEditProduct,
  onToggleStatus,
  onDeleteProduct
}) => {
  return (
    <div className="bg-[#1A1A1A] rounded-xl border border-white/8 overflow-hidden font-oranienbaum shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-white/8">
              <th className="px-5 py-3 text-left text-xs font-oranienbaum font-medium text-white/40 uppercase tracking-wider">
                Nombre del Producto
              </th>
              <th className="px-5 py-3 text-left text-xs font-oranienbaum font-medium text-white/40 uppercase tracking-wider">
                Estado
              </th>
              <th className="px-5 py-3 text-right text-xs font-oranienbaum font-medium text-white/40 uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {products?.length === 0 ? (
              <tr>
                <td colSpan="3" className="px-5 py-12 text-center text-white/30 font-oranienbaum text-base">
                  No se encontraron productos
                </td>
              </tr>
            ) : (
              products?.map((product) => (
                <tr
                  key={product?.id}
                  onClick={() => onSelectProduct(product)}
                  className={`cursor-pointer transition-colors duration-150 ${
                    selectedProduct?.id === product?.id
                      ? 'bg-[#D6EF4E]/5 border-l-2 border-l-[#D6EF4E]'
                      : 'hover:bg-white/3'
                  }`}
                >
                  <td className="px-5 py-3.5 whitespace-nowrap">
                    <span className="text-sm font-oranienbaum font-medium text-white">
                      {product?.nombre}
                    </span>
                  </td>
                  <td className="px-5 py-3.5 whitespace-nowrap">
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-oranienbaum font-medium border ${
                        product?.activo
                          ? 'bg-[#3A7F6B]/15 text-[#3A7F6B] border-[#3A7F6B]/30'
                          : 'bg-white/5 text-white/40 border-white/10'
                      }`}
                    >
                      {product?.activo ? 'Activo' : 'Desactivado'}
                    </span>
                  </td>
                  <td className="px-5 py-3.5 whitespace-nowrap text-right">
                    <div className="flex justify-end gap-1">
                      <button
                        onClick={(e) => { e?.stopPropagation(); onEditProduct(product); }}
                        className="p-1.5 rounded-lg text-[#8097D6] hover:bg-[#8097D6]/10 transition-colors"
                        title="Editar"
                      >
                        <Edit2 className="w-4 h-4" />
                      </button>
                      <button
                        onClick={(e) => { e?.stopPropagation(); onToggleStatus(product); }}
                        className={`p-1.5 rounded-lg transition-colors ${
                          product?.activo
                            ? 'text-[#E05252] hover:bg-[#E05252]/10'
                            : 'text-[#3A7F6B] hover:bg-[#3A7F6B]/10'
                        }`}
                        title={product?.activo ? 'Desactivar' : 'Activar'}
                      >
                        <Power className="w-4 h-4" />
                      </button>
                      <button
                        onClick={(e) => { e?.stopPropagation(); onDeleteProduct(product?.id); }}
                        className="p-1.5 rounded-lg text-[#E05252] hover:bg-[#E05252]/10 transition-colors"
                        title="Eliminar"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductGrid;